export default __webpack_public_path__ + "static/media/Peach waves_primary.1c7a65c9.jpg";